<template>
    <div class="widget-boxed">
		<div class="widget-boxed-header">
			<h4><i class="fa fa-commenting-o padd-r-10"></i>{{ $t('job-detail.message') }}</h4>
		</div>
		<div class="widget-boxed-body">
			<form>
				<input name="name" type="text" v-validate="'required'" class="form-control" :placeholder="$t('job-detail.name') + '*'" v-model="formData.name">
				<span>{{ errors.first('name') }}</span>
				<input name="email" v-validate="'required|email'" type="text" class="form-control" :placeholder="$t('job-detail.email') + '*'" v-model="formData.email">
				<span>{{ errors.first('email') }}</span>
				<input name="mobile" type="text" v-validate="'required|numeric'" class="form-control" :placeholder="$t('job-detail.mobile') + '*'" v-model="formData.mobile">
				<span>{{ errors.first('mobile') }}</span>
				<textarea name="message" class="form-control height-140" :placeholder="$t('job-detail.content')" v-model="formData.message"></textarea>
				<button class="btn theme-btn full-width" @click.prevent="sendMessage">{{ $t('job-detail.send') }}</button>
				<span>{{ $t('job-detail.agree') }}<router-link to="/terms">{{ $t('job-detail.terms') }}</router-link></span>
			</form>
		</div>
	</div>
</template>
<script>
export default {
  name: 'MessageForm',
  data: () => ({
	formData: {
	  'name': '',
	  'email': '',
	  'mobile': '',
	  'message': ''
	}
  }),
  methods: {
    sendMessage: function() {
      this.$validator.validate().then(result => {
        if (!result) {
          // do stuff if not valid.
          this.$message({
	          message: this.$t('job-detail.invalid'),
	          type: 'error'
	        })
        } else {
          this.$message({
	          message: this.$t('job-detail.sucess'),
	          type: 'success'
	        })
        }
      })
    },
    resetForm: function() {
      this.formData = {
		  'name': '',
		  'email': '',
		  'mobile': '',
		  'message': ''
		}
    }
  }
}
</script>